export default function getApiSaveTabFields(tab, binder) {
	const saveTab = {};
	// title is required to save
	if (tab.title !== undefined && tab.title !== null) {
		saveTab.title = tab.title;
	} else {
		saveTab.title = "New Tab";
	}

	if (tab.editable === true || tab.editable === false) {
		saveTab.editable = tab.editable;
	}

	const hasSearch = tab.search !== undefined && tab.search !== null;

	if (hasSearch) {
		saveTab.search = tab.search;
	}

	// content is required to save
	if (tab.content !== undefined && tab.content !== null) {
		//edge case for saving Party and Case tabs
		if (!hasSearch && !!binder && !tab.content.library_name) {
			saveTab.content = {
				library_name: binder.libraryName,
				profile_id: binder.id,
				profile_type: binder.type,
			};
		} else {
			saveTab.content = tab.content;
		}
	} else {
		saveTab.content = {};
	}

	if (tab.link_id) {
		saveTab.link_id = tab.link_id;
	}

	if (tab.tableau) {
		saveTab.tableau = tab.tableau;
	}

	if (tab.patent_cloud) {
		saveTab.patent_cloud = tab.patent_cloud;
	}

	if (tab.iFrame) {
		saveTab.iFrame = tab.iFrame;
	}

	return saveTab;
}
